import { flattenEdges, usePaginator } from "@pathwright/utils"
import { useMemo } from "react"
import { CamelCasedProperties } from "type-fest"
import { ContextModelInput, useNotesQuery } from "@pathwright/graphql-client/src/generated"
import { convertObjectKeysToSnakeCase } from "../utils/convertObjectKeys"

// The ContextModelInput uses snake_case keys but useNotes can accept either snake_case or camelCase.
// So, we expect either in the ContextInput type.
// TODO: localize this type.
export type ContextInput =
  | ContextModelInput
  | CamelCasedProperties<ContextModelInput>

const useNotes = ({
  variables,
  ...queryOptions
}: Parameters<typeof useNotesQuery>[0]) => {
  const notesQuery = useNotesQuery({
    variables: {
      ...variables,
      context: convertObjectKeysToSnakeCase(variables?.context!)
    },
    ...queryOptions
  })

  const notes = useMemo(
    () => (notesQuery.data ? flattenEdges(notesQuery.data.notes) || [] : []),
    [notesQuery.data]
  )

  const { loadMore, hasMore, loadingMore } = usePaginator({
    query: notesQuery,
    paginatorValue: notesQuery.data?.notes
  })

  return {
    notes,
    loadMore,
    hasMore,
    loadingMore,
    query: notesQuery
  }
}

export default useNotes
